module.exports = __webpack_public_path__ + "5f8421911fe48c1d527cffa2151af9f5.png";